const state = {
  previewMode: false,
  startMode: false,
};

const getters = {
  previewMode: (state) => state.previewMode,
  startMode: (state) => state.startMode,
};

const mutations = {
  SET_PREVIEW_MODE(state, value) {
    state.previewMode = value;
  },
  SET_START_MODE(state, value) {
    state.startMode = value;
  }
};

const actions = {
  setPreviewMode({ commit }, value) {
    commit('SET_PREVIEW_MODE', value);
  },
  setStartMode({ commit }, value) {
    commit('SET_START_MODE', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
